<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <span class="font-16 font-calibri font-weight-bold">EPF</span>
        <employee-profile-payroll-epf-detail-dialog-edit
          v-if="$hasPermissionTo(['update employee payroll']) && !isResigned"
          :epf-detail="epfDetail"
          :employee-uid="employeeUid"
          @updated="loadEmployeeEpf"
        />
      </v-col>
    </v-row>

    <v-row class="mx-0">
      <v-col class="pa-0">
        <span class="font-weight-medium">Member Number:</span>
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="20"
          width="3"
          color="primary"
          class="ml-3"
        />
        <span
          v-else
          class="pl-3"
        >
          {{ (epfDetail||{}).epf_member_number ||'N/A' }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollEpfDetailDialogEdit: () => import('@/components/hris/employee/profile/payroll/epf-detail/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        epfDetail: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeEpf()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeEpf () {
        this.loading = true

        this.$api.employeePayrollEpf().list(this.employeeUid)
          .then(res => {
            this.epfDetail = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}
</style>
